import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f7c817c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-grow-1" }, "Crear evento", -1))
const _hoisted_2 = { class: "px-6 pb-3" }
const _hoisted_3 = { class: "text-caption text-medium-emphasis" }
const _hoisted_4 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-warning mt-2 mb-0"
}
const _hoisted_6 = {
  key: 1,
  class: "text-caption text-medium-emphasis mt-2 mb-0"
}
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { class: "d-flex align-center" }
const _hoisted_9 = { class: "text-subtitle-2 font-weight-bold flex-grow-1" }
const _hoisted_10 = { class: "resumen" }
const _hoisted_11 = { class: "text-medium-emphasis" }

import { computed, nextTick, ref, watch } from "vue";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import { CrearTorneoDTO } from "@/interfaces/Torneo";
import { crearTorneo } from "@/services/TorneosService";
import { modoListasParejaOptions, tipoTorneoOptions, etiquetaLimitePlazas } from "@/Constant/TiposTorneo";
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import {
  ClassificationType,
  ClassificationTypeDescriptions,
  ClassificationTypeLabels,
  DESEMPATE_CLASIFICACION,
} from "@/Constant/TipoClasificacion";
import {
  DESEMPATE_GRUPOS,
  FORMATO_COPA,
  FORMATO_LIGA,
  FORMATO_SUIZO,
  REPARTO_ELO,
  cuentaEloOptions,
  desempateEliminatoriaOptions,
  esPorJornadas,
  idaYVueltaOptions,
  nombreEvento,
  repartoGruposOptions,
  tercerPuestoOptions,
  textosEvento,
  tipoEventoOptions,
} from "@/Constant/FormatoTorneo";
import { formatFechaSpaWhitoutAsync } from "@/utils/Fecha";

const tileLayerUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCrearTorneo',
  props: {
    isVisible: { type: Boolean },
    idUsuario: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const PASOS = ["Formato", "Datos", "Reglas", "Fechas", "Inscripción", "Revisar"];
const paso = ref(1);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const form = ref<any>(null);

const internalIsVisible = ref(props.isVisible);
watch(
  () => props.isVisible,
  visible => {
    internalIsVisible.value = visible;
    // Cada vez que se abre, desde el principio
    if (visible) paso.value = 1;
  }
);

// Lugar: se busca con OpenStreetMap
const searchQuery = ref<string>("");
const formattedAddress = ref<string>("");
const selectedLocation = ref<{ lat: number; lng: number } | null>(null);
const errorMessage = ref<string>("");
const zoom = ref<number>(14);
const isSearching = ref<boolean>(false);
// La dirección que se buscó: si se cambia el texto y no se vuelve a buscar, al pasar de paso se busca
const busquedaHecha = ref<string>("");

const searchLocation = async () => {
  const consulta = searchQuery.value.trim();
  if (!consulta) return;

  isSearching.value = true;
  const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
    consulta
  )}&addressdetails=1`;

  try {
    const response = await axios.get(url);
    if (response.data.length > 0) {
      const firstResult = response.data[0];
      selectedLocation.value = {
        lat: parseFloat(firstResult.lat),
        lng: parseFloat(firstResult.lon),
      };
      lugarTorneo.value = firstResult.lat + ", " + firstResult.lon;
      formattedAddress.value = formatAddress(firstResult);
      errorMessage.value = "";
    } else {
      errorMessage.value = "No se encontró la dirección. Se guardará sin enlace a Google Maps.";
      selectedLocation.value = null;
      lugarTorneo.value = consulta;
      formattedAddress.value = consulta;
    }
    busquedaHecha.value = consulta;
  } catch (error) {
    console.error("Error buscando la dirección:", error);
    errorMessage.value = "Error al buscar la dirección.";
  } finally {
    isSearching.value = false;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formatAddress = (data: any): string => {
  if (!data || !data.display_name) return "Dirección no disponible";
  const { name, address } = data;
  const road = address.road || name || "";
  const houseNumber = address.house_number ? `, ${address.house_number}` : "";
  const city = address.city || address.town || address.village || "";
  const state = address.state || "";
  const postcode = address.postcode || "";
  const country = address.country || "";
  return [`${road}${houseNumber}`, city, state, postcode, country].filter(Boolean).join(", ");
};

const nombreTorneo = ref<string>();
const limiteParticipantes = ref<number>();
const descripcionTorneo = ref<string>();
const precioTorneo = ref<number>();
const numeroPartidas = ref<number>();
const puntosTorneo = ref<number>();
const listasPorJugador = ref<number>();
const estadoTorneo = ref<number>(1);
const lugarTorneo = ref<string>();
const tipoTorneo = ref<string>("");
const listaPorPareja = ref<boolean>(false);
const esListaConjunta = computed(() => tipoTorneo.value === "Parejas" && listaPorPareja.value);
const formatoTorneo = ref<string>(FORMATO_SUIZO);
const cuentaElo = ref<boolean>(false);
const idaYVuelta = ref<boolean>(false);
const esLiga = computed(() => formatoTorneo.value === FORMATO_LIGA);
const esCopa = computed(() => formatoTorneo.value === FORMATO_COPA);
const porJornadas = computed(() => esPorJornadas(formatoTorneo.value));
// Solo en Copa
const numeroGrupos = ref<number>(2);
const clasificadosPorGrupo = ref<number>(2);
const repartoGrupos = ref<string>(REPARTO_ELO);
const desempateEliminatoria = ref<string>(DESEMPATE_GRUPOS);
const tercerPuesto = ref<boolean>(false);
// Los textos del formulario hablan del tipo de evento elegido
const textos = computed(() => textosEvento(formatoTorneo.value));
// Liga y Copa son individuales, con una lista por jugador, sin horario, y sus rondas son las jornadas que se generen
watch(porJornadas, jornadas => {
  if (!jornadas) return;
  tipoTorneo.value = "Individual";
  listasPorJugador.value = 1;
  numeroPartidas.value = 1;
  listaPorPareja.value = false;
  horaInicioTorneo.value = "00:00";
  horaFinTorneo.value = "00:00";
});
// Con lista conjunta cada pareja entrega una sola lista
watch(esListaConjunta, conjunta => {
  if (conjunta) listasPorJugador.value = 1;
});
const idRangoTorneo = ref<number>(1);
const esMatchedPlayTorneo = ref<boolean>(false);
const metodosPago = ref<string>("");
const horaInicioTorneo = ref<string>("00:00");
const horaFinTorneo = ref<string>("00:00");
const contacto = ref<string | undefined>(undefined);
const fechaInicioInscripcion = ref<string>("");
const fechaInicioTorneo = ref<string>("");
const fechaFinTorneo = ref<string>("");
const fechaFinEntregaListas = ref<string>("");
const fechaFinInscripcion = ref<string>("");
const isGenerating = ref<boolean>(false);
// Por qué no se ha podido crear, tal como lo cuenta el servidor
const errorCreacion = ref<string>("");
const showSuccessModal = ref<boolean>(false);
const mensajeCreado = ref<string>("");
const classificationType = ref<ClassificationType>();

// Bases y cartel: se guardan los ficheros para que no se pierdan al ir y volver entre pasos
const archivoBases = ref<File[] | File | null>(null);
const archivoCartel = ref<File[] | File | null>(null);
const byteArrayBases = ref<Uint8Array | null>(null);
const imageBase64 = ref<string | null>(null);
const primerFichero = (valor: File[] | File | null) => (Array.isArray(valor) ? valor[0] : valor) ?? null;

watch(archivoBases, valor => {
  const file = primerFichero(valor);
  if (!file) {
    byteArrayBases.value = null;
    return;
  }
  const reader = new FileReader();
  reader.onload = event => {
    if (event.target?.result) byteArrayBases.value = new Uint8Array(event.target.result as ArrayBuffer);
  };
  reader.readAsArrayBuffer(file);
});

// El cartel, a 500 px como mucho y en JPEG
watch(archivoCartel, valor => {
  const file = primerFichero(valor);
  if (!file) {
    imageBase64.value = null;
    return;
  }
  const reader = new FileReader();
  reader.onload = e => {
    const img = new Image();
    img.onload = () => {
      const maxWidth = 500;
      const maxHeight = 500;
      let width = img.width;
      let height = img.height;
      if (width > maxWidth || height > maxHeight) {
        if (width > height) {
          height *= maxWidth / width;
          width = maxWidth;
        } else {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);
        imageBase64.value = canvas.toDataURL("image/jpeg", 1);
      }
    };
    img.src = e.target?.result as string;
  };
  reader.readAsDataURL(file);
});

const classificationTypeOptions = [
  ClassificationType.NORMAL,
  ClassificationType.EXTENDED,
  ClassificationType.ALEMAN,
].map(value => ({
  label: ClassificationTypeLabels[value],
  subtitle: ClassificationTypeDescriptions[value].resumen,
  value,
}));

const today = new Date().toISOString().split("T")[0];

const validateRequired = (v: string) => !!v || "Campo obligatorio";
const validateNotPast = (v: string) => v >= today || "No puede ser una fecha pasada";
const validateFechaInicioFinTorneo = (v: string) =>
  !fechaFinTorneo.value || v <= fechaFinTorneo.value || "Debe ser anterior o igual a la fecha de fin";
const validateFechaFinInicioTorneo = (v: string) =>
  !fechaInicioTorneo.value || v >= fechaInicioTorneo.value || "Debe ser posterior o igual a la fecha de inicio";
const validateFinDespuesDeInicio =
  (inicio: string, mensaje = "Debe ser posterior o igual al inicio") =>
  (v: string) =>
    !inicio || !v || v >= inicio || mensaje;
const validateAntesDe = (fechaLimite: string, mensaje: string) => (v: string) =>
  !fechaLimite || !v || v <= fechaLimite || mensaje;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const validateHora = (v: any) => /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(v) || "Formato debe ser HH:MM";

// Las fechas dependen unas de otras: si ya hay avisos, al cambiar una se revisan todas, y no solo la que cambia
watch([fechaInicioTorneo, fechaFinTorneo, fechaInicioInscripcion, fechaFinInscripcion, fechaFinEntregaListas], async () => {
  if (paso.value !== 4 || !form.value?.$el.querySelector(".v-input--error")) return;
  await nextTick();
  form.value.validate();
});

// Solo se pasa de paso si el actual es válido
const siguiente = async () => {
  // Si se escribió una dirección y no se buscó, se busca ahora: así no se queda sin lugar
  if (paso.value === 2 && searchQuery.value.trim() && searchQuery.value.trim() !== busquedaHecha.value)
    await searchLocation();

  const { valid } = await form.value.validate();
  if (!valid) {
    // Al primer campo con error: en el móvil puede quedar fuera de la pantalla
    form.value.$el.querySelector(".v-input--error")?.scrollIntoView({ behavior: "smooth", block: "center" });
    return;
  }
  paso.value++;
};

// El resumen del último paso, por bloques
const conValor = (valor: unknown, sinValor = "—") =>
  valor === undefined || valor === null || valor === "" ? sinValor : String(valor);
const fecha = (valor: string) => (valor ? formatFechaSpaWhitoutAsync(valor) : "—");
const resumen = computed(() => {
  const tipo = tipoTorneoOptions.find(t => t.value === tipoTorneo.value)?.label ?? tipoTorneo.value;
  const opcion = (opciones: { value: unknown; label: string }[], valor: unknown) =>
    opciones.find(o => o.value === valor)?.label ?? conValor(valor);
  return [
    {
      paso: 1,
      filas: [
        { etiqueta: "Evento", valor: `${nombreEvento(formatoTorneo.value)} · ${tipo}` },
        ...(porJornadas.value ? [{ etiqueta: "Partidos", valor: opcion(idaYVueltaOptions, idaYVuelta.value) }] : []),
      ],
    },
    {
      paso: 2,
      filas: [
        { etiqueta: "Nombre", valor: conValor(nombreTorneo.value) },
        { etiqueta: "Lugar", valor: conValor(formattedAddress.value || lugarTorneo.value, "Sin lugar") },
        ...(contacto.value ? [{ etiqueta: "Contacto", valor: contacto.value }] : []),
      ],
    },
    {
      paso: 3,
      filas: [
        { etiqueta: "Puntos", valor: conValor(puntosTorneo.value) },
        ...(porJornadas.value
          ? [{ etiqueta: "ELO", valor: opcion(cuentaEloOptions, cuentaElo.value) }]
          : [
              { etiqueta: "Listas por jugador", valor: conValor(listasPorJugador.value) },
              { etiqueta: "Rondas", valor: conValor(numeroPartidas.value) },
            ]),
        ...(esCopa.value
          ? [{ etiqueta: "Grupos", valor: `${numeroGrupos.value}, pasan ${clasificadosPorGrupo.value} de cada uno` }]
          : []),
        {
          etiqueta: "Clasificación",
          valor: classificationType.value ? ClassificationTypeLabels[classificationType.value] : "—",
        },
      ],
    },
    {
      paso: 4,
      filas: [
        {
          etiqueta: textos.value.el.replace(/^\w/, c => c.toUpperCase()),
          valor:
            fechaFinTorneo.value > fechaInicioTorneo.value
              ? `Del ${fecha(fechaInicioTorneo.value)} al ${fecha(fechaFinTorneo.value)}`
              : `${fecha(fechaInicioTorneo.value)}${porJornadas.value ? "" : ` de ${horaInicioTorneo.value} a ${horaFinTorneo.value}`}`,
        },
        {
          etiqueta: "Inscripciones",
          valor: `Del ${fecha(fechaInicioInscripcion.value)} al ${fecha(fechaFinInscripcion.value)}`,
        },
        { etiqueta: "Listas hasta", valor: fecha(fechaFinEntregaListas.value) },
      ],
    },
    {
      paso: 5,
      filas: [
        { etiqueta: "Plazas", valor: conValor(limiteParticipantes.value) },
        { etiqueta: "Precio", valor: `${conValor(precioTorneo.value, "0")} €` },
        { etiqueta: "Bases", valor: primerFichero(archivoBases.value)?.name ?? "Sin bases" },
        { etiqueta: "Cartel", valor: primerFichero(archivoCartel.value)?.name ?? "Sin cartel" },
      ],
    },
  ];
});

const closeModal = () => {
  internalIsVisible.value = false;
  emit("close");
};

const confirmarConfiguracion = async () => {
  const basesTorneoBase64 = byteArrayBases.value
    ? btoa(new Uint8Array(byteArrayBases.value).reduce((data, byte) => data + String.fromCharCode(byte), ""))
    : null;

  const nuevoTorneo: CrearTorneoDTO = {
    idUsuario: props.idUsuario,
    nombreTorneo: nombreTorneo.value ?? "",
    limiteParticipantes: limiteParticipantes.value ?? 50,
    fechaInicioTorneo: fechaInicioTorneo.value ?? "",
    fechaFinTorneo: fechaFinTorneo.value ?? "",
    precioTorneo: precioTorneo.value ?? 0,
    numeroPartidas: numeroPartidas.value ?? 3,
    puntosTorneo: puntosTorneo.value ?? 500,
    estadoTorneo: estadoTorneo.value,
    lugarTorneo: lugarTorneo.value ?? "",
    tipoTorneo: tipoTorneo.value,
    idRangoTorneo: idRangoTorneo.value,
    esMatchedPlayTorneo: esMatchedPlayTorneo.value,
    fechaEntregaListas: fechaFinEntregaListas.value ?? "",
    fechaFinInscripcion: fechaFinInscripcion.value ?? "",
    horaInicioTorneo: horaInicioTorneo.value + ":00",
    horaFinTorneo: horaFinTorneo.value + ":00",
    cartelTorneo: imageBase64.value ?? "",
    basesTorneo: basesTorneoBase64 ?? "",
    descripcionTorneo: descripcionTorneo.value,
    // Antes no se mandaba y se perdía
    metodosPago: metodosPago.value || undefined,
    inicioInscripciones: fechaInicioInscripcion.value ?? "",
    listasPorJugador: listasPorJugador.value ?? 1,
    listaPorPareja: esListaConjunta.value,
    classificationType: classificationType.value ?? ClassificationType.NORMAL,
    contacto: contacto.value || undefined,
    formatoTorneo: formatoTorneo.value,
    cuentaElo: porJornadas.value && cuentaElo.value,
    idaYVuelta: porJornadas.value && idaYVuelta.value,
    ...(esCopa.value && {
      numeroGrupos: numeroGrupos.value,
      clasificadosPorGrupo: clasificadosPorGrupo.value,
      repartoGrupos: repartoGrupos.value,
      desempateEliminatoria: desempateEliminatoria.value,
      tercerPuesto: tercerPuesto.value,
    }),
  };

  errorCreacion.value = "";
  try {
    isGenerating.value = true;
    const respuesta = await crearTorneo(nuevoTorneo);
    mensajeCreado.value = esLiga.value
      ? "Liga creada correctamente."
      : esCopa.value
        ? "Copa creada correctamente."
        : "Torneo creado correctamente.";
    // Creado, pero con algo que avisar (p. ej. las bases no se han podido guardar)
    if (respuesta?.data?.aviso) mensajeCreado.value += ` ${respuesta.data.aviso}`;
    showSuccessModal.value = true;
    resetElement();
    emit("confirm");
    closeModal();
  } catch (error) {
    // Se queda abierto con todo rellenado, para corregirlo o volver a intentarlo
    errorCreacion.value =
      motivoDelError(error) ??
      "Ha fallado algo inesperado. Inténtalo de nuevo en un rato y, si sigue fallando, escríbenos desde Contacto.";
    console.error(error);
  } finally {
    isGenerating.value = false;
  }
};

// El motivo que manda el servidor: su mensaje, o qué datos no tienen el formato que espera
const motivoDelError = (error: unknown): string | null => {
  if (!axios.isAxiosError(error)) return null;
  if (!error.response) return "No se ha podido conectar con el servidor. Comprueba tu conexión y vuelve a intentarlo.";
  const data = error.response.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return data.message;
  if (data?.errors) {
    const campos = Object.keys(data.errors).map(campo => campo.replace(/^\$\./, ""));
    return `Algún dato no tiene el formato correcto (${campos.join(", ")}). Revisa los pasos y vuelve a intentarlo.`;
  }
  return null;
};

const resetElement = () => {
  errorCreacion.value = "";
  paso.value = 1;
  nombreTorneo.value = "";
  limiteParticipantes.value = undefined;
  fechaInicioTorneo.value = "";
  fechaFinTorneo.value = "";
  precioTorneo.value = undefined;
  numeroPartidas.value = undefined;
  puntosTorneo.value = undefined;
  lugarTorneo.value = "";
  searchQuery.value = "";
  busquedaHecha.value = "";
  formattedAddress.value = "";
  selectedLocation.value = null;
  errorMessage.value = "";
  fechaFinEntregaListas.value = "";
  fechaFinInscripcion.value = "";
  horaInicioTorneo.value = "00:00";
  horaFinTorneo.value = "00:00";
  archivoCartel.value = null;
  archivoBases.value = null;
  descripcionTorneo.value = "";
  metodosPago.value = "";
  fechaInicioInscripcion.value = "";
  listasPorJugador.value = undefined;
  listaPorPareja.value = false;
  tipoTorneo.value = "";
  classificationType.value = undefined;
  contacto.value = undefined;
  formatoTorneo.value = FORMATO_SUIZO;
  numeroGrupos.value = 2;
  clasificadosPorGrupo.value = 2;
  repartoGrupos.value = REPARTO_ELO;
  desempateEliminatoria.value = DESEMPATE_GRUPOS;
  tercerPuesto.value = false;
  cuentaElo.value = false;
  idaYVuelta.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: internalIsVisible.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((internalIsVisible).value = $event)),
      "max-width": "600px",
      scrollable: "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center pt-3" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  density: "comfortable",
                  "aria-label": "Cerrar",
                  onClick: closeModal
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, "Paso " + _toDisplayString(paso.value) + " de " + _toDisplayString(PASOS.length), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(PASOS[paso.value - 1]), 1),
              _createVNode(_component_v_progress_linear, {
                "model-value": (paso.value / PASOS.length) * 100,
                color: "primary",
                rounded: "",
                class: "mt-2"
              }, null, 8, ["model-value"])
            ]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  ref_key: "form",
                  ref: form,
                  onSubmit: _withModifiers(siguiente, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    (paso.value === 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_select, {
                            modelValue: formatoTorneo.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formatoTorneo).value = $event)),
                            label: "Tipo de evento",
                            items: _unref(tipoEventoOptions),
                            "item-title": "label",
                            "item-value": "value"
                          }, {
                            item: _withCtx(({ item, props }) => [
                              _createVNode(_component_v_list_item, _mergeProps(props, {
                                subtitle: item.raw.subtitle
                              }), null, 16, ["subtitle"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items"]),
                          (!porJornadas.value)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                type: "info",
                                variant: "tonal",
                                density: "compact",
                                class: "mb-4 text-left text-body-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Se juega por rondas. Las rondas se generan una a una desde la gestión del torneo y emparejan a jugadores con resultados parecidos según la clasificación. Cada jugador entrega su lista antes de empezar. ")
                                ]),
                                _: 1
                              }))
                            : (esLiga.value)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 1,
                                  type: "info",
                                  variant: "tonal",
                                  density: "compact",
                                  class: "mb-4 text-left text-body-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Cada jugador se enfrenta a todos los demás y elige su ejército al inscribirse. Las jornadas se generan desde la gestión cuando cierres las inscripciones: con N jugadores salen N−1 jornadas (N si son impares), el doble con ida y vuelta. ")
                                  ]),
                                  _: 1
                                }))
                              : (esCopa.value)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 2,
                                    type: "info",
                                    variant: "tonal",
                                    density: "compact",
                                    class: "mb-4 text-left text-body-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Los jugadores se reparten en grupos y en cada grupo juegan todos contra todos, por jornadas y con calendario abierto. Los mejores de cada grupo pasan a una eliminatoria que avanza sola. Cada jugador elige su ejército al inscribirse. ")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                          (porJornadas.value)
                            ? (_openBlock(), _createBlock(_component_v_select, {
                                key: 3,
                                modelValue: idaYVuelta.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((idaYVuelta).value = $event)),
                                label: esCopa.value ? '¿Grupos a solo ida o ida y vuelta?' : '¿Solo ida o ida y vuelta?',
                                items: _unref(idaYVueltaOptions),
                                "item-title": "label",
                                "item-value": "value"
                              }, null, 8, ["modelValue", "label", "items"]))
                            : _createCommentVNode("", true),
                          (!porJornadas.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createVNode(_component_v_select, {
                                  modelValue: tipoTorneo.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tipoTorneo).value = $event)),
                                  label: "¿De qué tipo es el torneo?",
                                  items: _unref(tipoTorneoOptions),
                                  "item-title": "label",
                                  "item-value": "value",
                                  hint: _unref(tipoTorneoOptions).find(t => t.value === tipoTorneo.value)?.subtitle,
                                  "persistent-hint": "",
                                  rules: [(v) => !!v || 'Campo obligatorio']
                                }, {
                                  item: _withCtx(({ item, props }) => [
                                    _createVNode(_component_v_list_item, _mergeProps(props, {
                                      subtitle: item.raw.subtitle
                                    }), null, 16, ["subtitle"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "items", "hint", "rules"]),
                                (tipoTorneo.value === 'Parejas')
                                  ? (_openBlock(), _createBlock(_component_v_select, {
                                      key: 0,
                                      modelValue: listaPorPareja.value,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((listaPorPareja).value = $event)),
                                      label: "¿Cómo entregan las listas las parejas?",
                                      items: _unref(modoListasParejaOptions),
                                      "item-title": "label",
                                      "item-value": "value"
                                    }, null, 8, ["modelValue", "items"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (paso.value === 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_text_field, {
                              modelValue: nombreTorneo.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((nombreTorneo).value = $event)),
                              label: `Nombre ${textos.value.del}`,
                              type: "text",
                              counter: "200",
                              rules: [
                (v) => !!v || 'Campo obligatorio',
                (v) => !v || v.length <= 200 || 'Como mucho 200 caracteres',
              ]
                            }, null, 8, ["modelValue", "label", "rules"]),
                            _createVNode(_component_v_textarea, {
                              modelValue: descripcionTorneo.value,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((descripcionTorneo).value = $event)),
                              label: `Descripción ${textos.value.del} (opcional)`,
                              rows: "3",
                              "auto-grow": "",
                              clearable: ""
                            }, null, 8, ["modelValue", "label"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: searchQuery.value,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchQuery).value = $event)),
                              label: `¿Dónde se celebra ${textos.value.el}?`,
                              placeholder: "Ej: Calle Gran Vía, Madrid",
                              loading: isSearching.value,
                              hint: "Si no lo encuentra, se guarda tal cual, sin enlace a Google Maps",
                              "persistent-hint": "",
                              onKeydown: _withKeys(_withModifiers(searchLocation, ["prevent"]), ["enter"])
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  variant: "tonal",
                                  onClick: searchLocation
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Buscar")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "label", "loading", "onKeydown"]),
                            (errorMessage.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errorMessage.value), 1))
                              : (formattedAddress.value)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Dirección: " + _toDisplayString(formattedAddress.value), 1))
                                : _createCommentVNode("", true),
                            (selectedLocation.value)
                              ? (_openBlock(), _createBlock(_unref(LMap), {
                                  key: 2,
                                  zoom: zoom.value,
                                  center: [selectedLocation.value.lat, selectedLocation.value.lng],
                                  options: { dragging: false, zoomControl: false, scrollWheelZoom: false },
                                  class: "mt-3",
                                  style: {"height":"220px","width":"100%","border-radius":"4px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(LTileLayer), { url: tileLayerUrl }),
                                    _createVNode(_unref(LMarker), { "lat-lng": selectedLocation.value }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(LPopup), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(formattedAddress.value), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["lat-lng"])
                                  ]),
                                  _: 1
                                }, 8, ["zoom", "center"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_text_field, {
                              modelValue: contacto.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((contacto).value = $event)),
                              label: "Contacto (email o teléfono, opcional)",
                              hint: "El contacto será visible si se rellena",
                              "persistent-hint": "",
                              clearable: "",
                              type: "text",
                              class: "mt-4"
                            }, null, 8, ["modelValue"])
                          ], 64))
                        : (paso.value === 3)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_v_text_field, {
                                modelValue: puntosTorneo.value,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((puntosTorneo).value = $event)),
                                label: `¿A cuántos puntos es ${textos.value.el}?`,
                                type: "number",
                                rules: [
                (v) => !isNaN(v) || 'Debe ser un número',
                (v) => v > 0 || 'Debe ser mayor que 0',
              ]
                              }, null, 8, ["modelValue", "label", "rules"]),
                              (!porJornadas.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: listasPorJugador.value,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((listasPorJugador).value = $event)),
                                      label: "¿Cuántas listas necesitará un jugador?",
                                      type: "number",
                                      disabled: esListaConjunta.value,
                                      hint: esListaConjunta.value ? 'Con lista conjunta cada pareja entrega una' : '',
                                      "persistent-hint": "",
                                      rules: [
                  (v) => !isNaN(v) || 'Debe ser un número',
                  (v) => v > 0 || 'Debe ser mayor que 0',
                ]
                                    }, null, 8, ["modelValue", "disabled", "hint", "rules"]),
                                    _createVNode(_component_v_text_field, {
                                      modelValue: numeroPartidas.value,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((numeroPartidas).value = $event)),
                                      label: "¿Cuántas rondas tiene el torneo?",
                                      type: "number",
                                      rules: [
                  (v) => !isNaN(v) || 'Debe ser un número',
                  (v) => v > 0 || 'Debe ser mayor que 0',
                ]
                                    }, null, 8, ["modelValue", "rules"])
                                  ], 64))
                                : (_openBlock(), _createBlock(_component_v_select, {
                                    key: 1,
                                    modelValue: cuentaElo.value,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((cuentaElo).value = $event)),
                                    label: "¿Cuenta para el ELO?",
                                    items: _unref(cuentaEloOptions),
                                    "item-title": "label",
                                    "item-value": "value"
                                  }, null, 8, ["modelValue", "items"])),
                              (esCopa.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: numeroGrupos.value,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((numeroGrupos).value = $event)),
                                      modelModifiers: { number: true },
                                      type: "number",
                                      label: "¿Cuántos grupos?",
                                      rules: [
                  (v) => v >= 1 || 'Al menos un grupo',
                  (v) => v <= 32 || 'Como mucho 32 grupos',
                ]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_v_text_field, {
                                      modelValue: clasificadosPorGrupo.value,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((clasificadosPorGrupo).value = $event)),
                                      modelModifiers: { number: true },
                                      type: "number",
                                      label: "¿Cuántos pasan de cada grupo?",
                                      hint: "Si no llenan el cuadro, entran los mejores siguientes",
                                      "persistent-hint": "",
                                      rules: [
                  (v) => v >= 1 || 'Al menos uno',
                  (v) => numeroGrupos.value * v >= 2 || 'A la eliminatoria tienen que pasar al menos dos',
                ],
                                      class: "mb-2"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_v_select, {
                                      modelValue: repartoGrupos.value,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((repartoGrupos).value = $event)),
                                      label: "¿Cómo se reparten los grupos?",
                                      items: _unref(repartoGruposOptions),
                                      "item-title": "label",
                                      "item-value": "value"
                                    }, {
                                      item: _withCtx(({ item, props }) => [
                                        _createVNode(_component_v_list_item, _mergeProps(props, {
                                          subtitle: item.raw.subtitle
                                        }), null, 16, ["subtitle"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "items"]),
                                    _createVNode(_component_v_select, {
                                      modelValue: desempateEliminatoria.value,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((desempateEliminatoria).value = $event)),
                                      label: "Empate en la eliminatoria",
                                      items: _unref(desempateEliminatoriaOptions),
                                      "item-title": "label",
                                      "item-value": "value"
                                    }, {
                                      item: _withCtx(({ item, props }) => [
                                        _createVNode(_component_v_list_item, _mergeProps(props, {
                                          subtitle: item.raw.subtitle
                                        }), null, 16, ["subtitle"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "items"]),
                                    _createVNode(_component_v_select, {
                                      modelValue: tercerPuesto.value,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((tercerPuesto).value = $event)),
                                      label: "¿Tercer puesto?",
                                      items: _unref(tercerPuestoOptions),
                                      "item-title": "label",
                                      "item-value": "value"
                                    }, null, 8, ["modelValue", "items"])
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_select, {
                                modelValue: classificationType.value,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((classificationType).value = $event)),
                                label: "¿Qué tipo de clasificación se utilizará?",
                                items: _unref(classificationTypeOptions),
                                "item-title": "label",
                                "item-value": "value",
                                rules: [(v) => !!v || 'Campo obligatorio']
                              }, {
                                item: _withCtx(({ item, props }) => [
                                  _createVNode(_component_v_list_item, _mergeProps(props, {
                                    subtitle: item.raw.subtitle
                                  }), null, 16, ["subtitle"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "items", "rules"]),
                              (classificationType.value)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 3,
                                    type: "info",
                                    variant: "tonal",
                                    density: "compact",
                                    class: "mb-4 text-left text-body-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(ClassificationTypeDescriptions)[classificationType.value].detalle) + " " + _toDisplayString(_unref(DESEMPATE_CLASIFICACION)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (paso.value === 4)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createVNode(_component_v_row, { dense: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      sm: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: fechaInicioTorneo.value,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((fechaInicioTorneo).value = $event)),
                                          label: `Inicio ${textos.value.del}`,
                                          type: "date",
                                          rules: [validateRequired, validateNotPast, validateFechaInicioFinTorneo]
                                        }, null, 8, ["modelValue", "label", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      sm: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: fechaFinTorneo.value,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((fechaFinTorneo).value = $event)),
                                          label: `Fin ${textos.value.del}`,
                                          type: "date",
                                          rules: [validateRequired, validateFechaFinInicioTorneo]
                                        }, null, 8, ["modelValue", "label", "rules"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (!porJornadas.value)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      dense: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "6" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                              modelValue: horaInicioTorneo.value,
                                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((horaInicioTorneo).value = $event)),
                                              label: "Hora de inicio",
                                              placeholder: "HH:MM",
                                              clearable: "",
                                              rules: [validateHora]
                                            }, null, 8, ["modelValue", "rules"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "6" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                              modelValue: horaFinTorneo.value,
                                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((horaFinTorneo).value = $event)),
                                              label: "Hora de fin",
                                              placeholder: "HH:MM",
                                              clearable: "",
                                              rules: [validateHora]
                                            }, null, 8, ["modelValue", "rules"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_row, { dense: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      sm: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: fechaInicioInscripcion.value,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((fechaInicioInscripcion).value = $event)),
                                          label: "Inicio de las inscripciones",
                                          type: "date",
                                          clearable: "",
                                          rules: [
                    validateRequired,
                    validateAntesDe(fechaFinInscripcion.value, 'Debe ser antes de la fecha de fin de inscripción'),
                    validateAntesDe(fechaInicioTorneo.value, `Debe ser antes de la fecha de inicio ${textos.value.del}`),
                  ]
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      sm: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: fechaFinInscripcion.value,
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((fechaFinInscripcion).value = $event)),
                                          label: `Último día para apuntarse ${textos.value.al}`,
                                          type: "date",
                                          rules: [
                    validateRequired,
                    validateFinDespuesDeInicio(fechaInicioInscripcion.value, 'Debe ser posterior al inicio de inscripción'),
                    validateAntesDe(fechaInicioTorneo.value, `Debe ser antes del inicio ${textos.value.del}`),
                  ]
                                        }, null, 8, ["modelValue", "label", "rules"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_text_field, {
                                  modelValue: fechaFinEntregaListas.value,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((fechaFinEntregaListas).value = $event)),
                                  label: porJornadas.value ? 'Último día para entregar la primera lista' : 'Último día para entregar las listas',
                                  hint: porJornadas.value ? 'Después cada jugador puede cambiarla en cada jornada' : '',
                                  "persistent-hint": "",
                                  type: "date",
                                  rules: [
                validateRequired,
                validateFinDespuesDeInicio(fechaFinInscripcion.value, 'Debe ser posterior al cierre de inscripciones'),
                validateAntesDe(fechaInicioTorneo.value, `Debe ser antes del inicio ${textos.value.del}`),
              ]
                                }, null, 8, ["modelValue", "label", "hint", "rules"])
                              ], 64))
                            : (paso.value === 5)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: limiteParticipantes.value,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((limiteParticipantes).value = $event)),
                                    label: _unref(etiquetaLimitePlazas)(tipoTorneo.value),
                                    type: "number",
                                    rules: [
                (v) => !isNaN(v) || 'Debe ser un número',
                (v) => v > 0 || 'Debe ser mayor que 0',
              ]
                                  }, null, 8, ["modelValue", "label", "rules"]),
                                  _createVNode(_component_v_text_field, {
                                    modelValue: precioTorneo.value,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((precioTorneo).value = $event)),
                                    label: `¿Cuál es el precio ${textos.value.del}?`,
                                    type: "number",
                                    suffix: "€",
                                    rules: [(v) => !isNaN(v) || 'Debe ser un número']
                                  }, null, 8, ["modelValue", "label", "rules"]),
                                  _createVNode(_component_v_textarea, {
                                    modelValue: metodosPago.value,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((metodosPago).value = $event)),
                                    label: "¿Cómo se puede pagar? (opcional)",
                                    rows: "2",
                                    "auto-grow": "",
                                    clearable: ""
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_component_v_file_input, {
                                    modelValue: archivoBases.value,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((archivoBases).value = $event)),
                                    label: `Bases ${textos.value.del} en PDF (opcional)`,
                                    accept: "application/pdf",
                                    "prepend-icon": "",
                                    "prepend-inner-icon": "mdi-file-pdf-box",
                                    "show-size": "",
                                    clearable: ""
                                  }, null, 8, ["modelValue", "label"]),
                                  _createVNode(_component_v_file_input, {
                                    modelValue: archivoCartel.value,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((archivoCartel).value = $event)),
                                    label: "Cartel (opcional)",
                                    accept: "image/*",
                                    "prepend-icon": "",
                                    "prepend-inner-icon": "mdi-image",
                                    "show-size": "",
                                    clearable: ""
                                  }, null, 8, ["modelValue"])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  (errorCreacion.value)
                                    ? (_openBlock(), _createBlock(_component_v_alert, {
                                        key: 0,
                                        type: "error",
                                        variant: "tonal",
                                        density: "compact",
                                        class: "mb-4 text-left"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_7, "No se ha podido crear " + _toDisplayString(textos.value.el), 1),
                                          _createTextVNode(" " + _toDisplayString(errorCreacion.value), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resumen.value, (bloque) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: bloque.paso,
                                      class: "mb-3"
                                    }, [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(PASOS[bloque.paso - 1]), 1),
                                        _createVNode(_component_v_btn, {
                                          variant: "text",
                                          size: "small",
                                          class: "text-none",
                                          onClick: ($event: any) => (paso.value = bloque.paso)
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Cambiar")
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _createElementVNode("dl", _hoisted_10, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bloque.filas, (fila) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: fila.etiqueta,
                                            class: "fila"
                                          }, [
                                            _createElementVNode("dt", _hoisted_11, _toDisplayString(fila.etiqueta), 1),
                                            _createElementVNode("dd", null, _toDisplayString(fila.valor), 1)
                                          ]))
                                        }), 128))
                                      ])
                                    ]))
                                  }), 128))
                                ], 64))
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, { class: "px-4 py-3" }, {
              default: _withCtx(() => [
                (paso.value > 1)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "text",
                      disabled: isGenerating.value,
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (paso.value--))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Atrás")
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      variant: "text",
                      onClick: closeModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancelar")
                      ]),
                      _: 1
                    })),
                _createVNode(_component_v_spacer),
                (paso.value < PASOS.length)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 2,
                      color: "primary",
                      variant: "flat",
                      loading: isSearching.value,
                      onClick: siguiente
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Siguiente ")
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : (_openBlock(), _createBlock(_component_v_btn, {
                      key: 3,
                      color: "primary",
                      variant: "flat",
                      loading: isGenerating.value,
                      onClick: confirmarConfiguracion
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Crear " + _toDisplayString(_unref(nombreEvento)(formatoTorneo.value).toLowerCase()), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: mensajeCreado.value,
      "onUpdate:isVisible": _cache[32] || (_cache[32] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible", "message"])
  ], 64))
}
}

})